export default [
  { path: 'finauto/vat_rates', component: () => import('./pages/VatRates.vue') },
  { path: 'finauto/media_vat_rates', component: () => import('./pages/MediaVatRates.vue') },
  { path: 'finauto/tax_accrual', component: () => import('./pages/TaxAccrual.vue') },
  { path: 'finauto/opti_prices', component: () => import('./pages/OptiPrices.vue') },
  { path: 'finauto/opti_pricelists', component: () => import('./pages/OptiPriceLists.vue') },
  { path: 'finauto/opti_offers/:id?/:section?', component: () => import('./pages/OptiOffers.vue') }
]
